import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keysToArray',
})
export class KeysToArrayPipe implements PipeTransform {
  transform<Type extends object>(
    data: Type | null | undefined,
  ): (keyof Type)[] {
    if (!data) {
      return [];
    }
    return Object.keys(data) as (keyof Type)[];
  }
}
